import UnauthorizedBase from "../../Base/views/UnauthorizedBase";
import {
  TextField,
  FormControl,
  Typography,
  Button,
  Box,
  Card,
  CardContent,
  CardMedia,
  InputAdornment,
  Link,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { AdminSigninHelper } from "../../SignIn/helper/AdminSigninHelper";
import RequestSvg from "../../../../svg/RequestSvg";
import history from "../../../../history.js";

const MeeplAdminSigninPage = () => {
  const initialValues = { emailid: "", password: "" };
  const [signUpData, setSignUpData] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignUpData((prev) => ({ ...prev, [name]: value }));
    validateField(name, value); // live validation
  };

  const validateField = (name, value) => {
    let error = "";
    if (name === "emailid") {
      if (!value) error = "Email is required";
      else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
      ) {
        error = "Invalid Email";
      }
    }
    if (name === "password" && !value) error = "Password is required";
    setErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const validateAll = () =>
    Object.entries(signUpData).every(([key, val]) =>
      validateField(key, val)
    );

  const handleSubmit = async () => {
    setFormError("");

    // validate all fields only on submit
    const isValid = validateAll();
    if (!isValid) return;

    setLoading(true);
    try {
      const res = await AdminSigninHelper(signUpData);

      if (res?.success) {
        setSignUpData(initialValues);
        history.push("/admin/dashboard");
      } else {
        setFormError(res?.message || "Invalid email or password");
        setSignUpData((prev) => ({ ...prev, password: "" })); // clear only password
      }
    } catch (err) {
      setFormError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleForgotPasswordClick = () => {
    history.push({
      pathname: "/forgotPassword",
      state: { defaultValue: "meepladmin" },
    });
  };

  return (
    <UnauthorizedBase>
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <Card
          sx={{
            boxShadow:
              "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 10px 8px",
            borderRadius: 2,
            width: "28rem",
          }}
        >
          <CardMedia sx={{ p: 2, textAlign: "center" }}>
            <div style={{ marginBottom: "40px", height: "126px" }}>
              <RequestSvg />
            </div>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Typography variant="h3">Admin</Typography>
            </Box>
          </CardMedia>

          <CardContent>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <FormControl fullWidth>
                <TextField
                  sx={{ mt: 2 }}
                  type="email"
                  required
                  InputLabelProps={{ shrink: true }}
                  placeholder="Enter the Email"
                  autoFocus
                  label="Email"
                  name="emailid"
                  autoComplete="email"
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  value={signUpData.emailid}
                  error={!!errors.emailid}
                  helperText={errors.emailid}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  sx={{ mt: 2 }}
                  InputLabelProps={{ shrink: true }}
                  label="Password"
                  placeholder="Enter the Password"
                  type={showPassword ? "text" : "password"}
                  required
                  onKeyDown={handleKeyDown}
                  name="password"
                  autoComplete="current-password"
                  onChange={handleChange}
                  value={signUpData.password}
                  error={!!errors.password}
                  helperText={errors.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              {formError && (
                <Typography
                  color="error"
                  variant="body2"
                  sx={{ mt: 1, textAlign: "center" }}
                >
                  {formError}
                </Typography>
              )}

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Link
                  onClick={handleForgotPasswordClick}
                  variant="body2"
                  sx={{
                    cursor: "pointer",
                    fontSize: "15px",
                    color: "black",
                    pt: 2,
                  }}
                >
                  Forgot Password
                </Link>
              </Box>

              <Button
                className="mpl-primary-btn"
                variant="contained"
                sx={{ mt: 3, height: "3rem" }}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "Submit"}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </UnauthorizedBase>
  );
};

export default MeeplAdminSigninPage;